import { render, staticRenderFns } from "./DateFilters.vue?vue&type=template&id=25cf0010&"
import script from "./DateFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DateFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cf0010')) {
      api.createRecord('25cf0010', component.options)
    } else {
      api.reload('25cf0010', component.options)
    }
    module.hot.accept("./DateFilters.vue?vue&type=template&id=25cf0010&", function () {
      api.rerender('25cf0010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DateFilters/DateFilters.vue"
export default component.exports